"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.postJson = exports.Config = void 0;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Config = function () {
  var config = null;
  return function Configger(_config) {
    if (!arguments.length) {
      return config;
    }

    config = _objectSpread({}, _config);
    Object.assign(Configger, _config);
    return Configger;
  };
}();

exports.Config = Config;

var postJson = function postJson(url, body) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return fetch(url, _objectSpread({
    method: "POST",
    headers: {
      Accept: 'application/json, text/plain',
      "Content-type": "application/json"
    },
    body: JSON.stringify(body)
  }, options)).then(function (r) {
    if (r.ok) {
      return r.json();
    }

    throw new Error("There was a network problem.");
  });
};

exports.postJson = postJson;